import React from "react";
import Button from "../shared-components/Button";
import { useNavigate } from "react-router-dom";

type Props = {
  noQueue?: boolean;
};

function buildPageData(noQueue: boolean) {
  if (noQueue) {
    return {
      title: "Tasks Complete",
      text: "You’ve completed all your assigned tasks. Please refresh the page. If that doesn’t resolve the issue, please check in with your team leader for additional tasks.",
      buttonText: "Refresh",
    };
  }

  return {
    title: "Welcome",
    text: "Welcome to your work queue. Click “Enter Work Queue” to begin your tasks for the day. Let’s make progress!",
    buttonText: "Enter Work Queue",
  };
}

const ReportsTasksQueue = (props: Props) => {
  const navigate = useNavigate();

  const pageData = buildPageData(props.noQueue ?? false);

  return (
    <div className="flex flex-col items-center justify-center h-screen">
      <div className="text-5xl leading-9 font-bold text-center text-gray-900 mb-4">
        {pageData.title}
      </div>
      <div className="leading-5 text-center text-gray-500 w-[500px] mb-5">
        {pageData.text}
      </div>
      <div>
        <Button
          text={pageData.buttonText}
          onClick={() => {
            navigate("/reports/next_task", { state: { stepDone: true } });
          }}
        ></Button>
      </div>
    </div>
  );
};

export default ReportsTasksQueue;
